<template>
  <div>
    <b-row>
      <b-col md="8" style="text-align: right;"><h2>{{selected_item_text || "Select Dropdown"}} Product Listing</h2></b-col>
      <b-col md="4" style="text-align: left;">
        <b-button-group v-b-hover="handleHover" vertical>
          <b-button size="sm" v-if="showUndo"
            :variant="isHovered ? 'warning' : 'primary'"
            class="mb-2"
            v-b-tooltip.hover.right title="Select Product Listing"
            @click="unsetSelection"
            >
            <b-icon-arrow-clockwise aria-label="Undo"></b-icon-arrow-clockwise>
          </b-button>
        </b-button-group>
      </b-col>
    </b-row>
    <div v-if="showTable">
      <product-listing-select
        :select_table_heading="no_heading"
        :filtering="filtering"
        @selectedItems="setSelection"
      >
      </product-listing-select>
    </div>
  </div>
</template>

<script>
import ProductListingSelect from './ProductListingSelect.vue'
import {
  BIconArrowClockwise
} from 'bootstrap-vue'

export default {
  components: {
    ProductListingSelect,
    BIconArrowClockwise
  },
  props: {
    collection_id: String,
    heading: {
      Type: String
    },
    filtering: {
      Type: Object
    }
  },
  data () {
    return {
      isHovered: false,
      select_item_id: undefined,
      selected_item_text: undefined,
      no_heading: ""
    }
  },
  computed: {
    showUndo() {
      return this.select_item_id !== undefined
    },
    showTable() {
      return this.select_item_id === undefined
    }
  },
  methods: {
    handleHover(hovered) {
      this.isHovered = hovered
    },
    setSelection(items) {
      this.select_item_id = items[0].id
      this.selected_item_text = `#${items[0].attributes['edition']} ${items[0].attributes['description']}`
      this.$emit('selectedItems', items)
    },
    unsetSelection() {
      this.select_item_id = undefined
      this.selected_item_text = undefined
    }
  }
}
</script>
